import { Component, Input } from "@angular/core";
import { ProductDataForSwift } from "../../../../../../model/finzy-flex/product-list.model";

@Component({
    selector: 'app-investment-options',
    templateUrl: './investment-options.component.html',
    styleUrls: ['./investment-options.component.scss']
})
export class InvestmentOptionsComponent {
    @Input() investmentOptions: ProductDataForSwift[];
}